module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chigunn0010#pre"
    }
  }, [_vm._v("Preambling toward Profligacy")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chigunn0011#intro"
    }
  }, [_vm._v("Introduction: Eating Poorly, or Ketchup on a Steak")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chigunn0012#ch01"
    }
  }, [_vm._v("1   On Critical Violence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chigunn0013#ch02"
    }
  }, [_vm._v("2   The Psychoses of Speed, with the Example of Social Networking")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chigunn0014#ch03"
    }
  }, [_vm._v("3   The Perverse Style, with Eventual Reference to Pee-wee Herman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chigunn0015#ch04"
    }
  }, [_vm._v("4   Showmancing the Presidency: Perverse Genres and the Problem of Judgment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chigunn0016#conc"
    }
  }, [_vm._v("Conclusion: Don’t Play (with) That")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chigunn0017#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chigunn0018#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chigunn0020#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d870878","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-gunn-0008.vue
// module id = 75
// module chunks = 0